import React from 'react';
import Ambassador from '../components/ambassador.component';
import Header from '../components/header.component';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import { SectionHeader } from "./../components/common/section-header.component";
import { useTranslation } from 'react-i18next';

import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
export const AmbassadorPage: React.FC = () => {
     const { t, i18n } = useTranslation();
   
       const currentLanguage = i18n.language;
   
       const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
       const canonicalUrl = isEnglish
           ? `https://www.invozio.com/ambassador?lang=${LOCALES.EN_US}`
           : `https://www.invozio.com/ambassador?lang=${LOCALES.SV_SE}`;
       const schemaMarkup = getSchemaMarkup("ambassador");
    return (
        <>
            <Header />
            <SEOMetadataComponent
                title={t('BECOME_AN_AMBASSADOR')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
              <SectionHeader
                            titleKey={t('BECOME_AN_AMBASSADOR')}
                            className="invozio-news-section"
                            titleClassName="main-title"
                            subtitleClassName="sub-title"
                            alignment="center"
                        />
            <Ambassador />
            <div className="bg-footer">
                <AccountAccess />
                <Footer />
            </div>
        </>
    );
};

export default AmbassadorPage;

